(function () {
  "use strict";

  /**
   * Do not dismiss the homepage intro from here — wearth-intro.js owns timing
   * (Klaviyo can open mid-type; intro snaps to full text then finishes).
   */

  function klaviyoOpen() {
    return !!document.querySelector(".klaviyo-form, [data-testid='klaviyo-form']");
  }

  function unlockBodyIfKlaviyoClosed() {
    if (klaviyoOpen()) return;
    if (!document.body.classList.contains("klaviyo-prevent-body-scrolling")) return;
    document.body.classList.remove("klaviyo-prevent-body-scrolling");
    document.body.style.removeProperty("overflow");
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    document.body.style.removeProperty("width");
  }

  function sync() {
    unlockBodyIfKlaviyoClosed();
  }

  sync();
  var obs = new MutationObserver(sync);
  obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest(".klaviyo-close-form")) {
      window.setTimeout(unlockBodyIfKlaviyoClosed, 400);
    }
  });
})();
